import React, { FC, useEffect, useState } from "react";

import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

import { EstimatedCostRoyaltiesType, estimatedcosts, getEstimatedCostRoyalties } from "../../../lib/api/estimatedcost";
import Grid from "../../../lib/components/grid";
import { GridColumns } from "./estimatedcostgridsetup";
import { whoami } from "../../../lib/api/_base";
import Confirmation from "../../../lib/components/confirmation";

import numeral from "numeral";
import LinearProgress from "@material-ui/core/LinearProgress";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      paddingTop: "65px",
    },
    tableCell: {
      borderWidth: "1px",
      paddingLeft: "2px",
      paddingRight: "2px",
      borderColor: "black",
      borderStyle: "solid",
      width: "200px",
    },
    tableCellValue: {
      borderWidth: "1px",
      paddingLeft: "2px",
      paddingRight: "2px",
      borderColor: "black",
      borderStyle: "solid",
      width: "100px",
      textAlign: "right",
    },
  });

type EstimatedCostGridProps = {
  handleCopy: any;
  handleEdit: any;
  handleRemove: any;
  data: any;
  dataLoading: any;
  loadData(): void;
} & WithStyles<typeof styles>;

class EstimatedCostGridUnstyled extends React.Component<EstimatedCostGridProps, {}> {
  state = {
    classes: undefined,
    handleCopy: undefined,
    handleEdit: undefined,
    handleRemove: undefined,
    hideCompleted: undefined,
    user: undefined,
    estCostID: undefined,
  };

  constructor(props) {
    super(props);
    this.state.classes = props.classes;
    this.state.handleCopy = props.handleCopy;
    this.state.handleEdit = props.handleEdit;
    this.state.handleRemove = props.handleRemove;
  }

  async componentDidMount() {
    const user = await whoami();
    this.setState({ user });
  }

  GridColumnsOverride = (column: any, row: any, columnArrangement?: any, columnsWidth?: any) => {
    return GridColumns(
      column,
      row,
      columnArrangement,
      columnsWidth,
      this.state.handleCopy,
      this.state.handleEdit,
      this.state.handleRemove,
      this.handleChangeStatus,
      this.state.user,
      this.handleViewRoyalties,
    );
  };

  handleChangeStatus = async (ec) => {
    const newStatus = ec.status == 1 ? 0 : 1;
    const updateData = {
      data: {
        status: newStatus,
      },
    };
    await estimatedcosts.update(ec.id, updateData);
    this.props.loadData();
  };

  handleViewRoyalties = (id: number) => {
    this.setState({ estCostID: id });
  };

  render() {
    const { classes } = this.state;

    return (
      <div className={classes.root}>
        <div style={{ marginBottom: "-75px", width: "300px", marginLeft: "17px" }}>{this.props.dataLoading && <CircularProgress size={24} />}</div>
        {this.state.estCostID && (
          <Confirmation
            isOpen
            body={undefined}
            title={"Royalties"}
            handleClose={() => this.setState({ estCostID: undefined })}
            handleConfirm={() => this.setState({ estCostID: undefined })}
          >
            <EstimatedCostRoyalties estcostid={this.state.estCostID} />
          </Confirmation>
        )}
        <Grid data={this.props.data} GridColumns={this.GridColumnsOverride} clearFilters={"estimatedcostgridsetup"} handleRefresh={() => this.props.loadData()} />
      </div>
    );
  }
}

type EstimatedCostRoyaltiesProps = {
  estcostid: number;
} & WithStyles<typeof styles>;

const EstimatedCostRoyaltiesUnstyled: FC<EstimatedCostRoyaltiesProps> = ({ estcostid, classes }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<EstimatedCostRoyaltiesType[]>([]);

  const loadData = async () => {
    setLoading(true);
    try {
      const result = await getEstimatedCostRoyalties(estcostid);
      setData(result);
    } catch (error) {}
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, [estcostid]);

  return (
    <div>
      {loading && <LinearProgress color="secondary" style={{ width: "100%", marginBottom: "1rem" }} />}
      <table>
        <tbody>
          <tr style={{ fontWeight: "bold" }}>
            <td className={classes.tableCell}>Group</td>
            <td className={classes.tableCell}>Description</td>
            <td className={classes.tableCellValue}>USD</td>
            <td className={classes.tableCellValue}>EUR</td>
            <td className={classes.tableCellValue}>GBP</td>
            <td className={classes.tableCellValue}>CAD</td>
            <td className={classes.tableCellValue}>ZAR</td>
            <td className={classes.tableCell}>Varieties</td>
          </tr>
          {data.map((di) => (
            <tr key={`row${di.id}`}>
              <td className={classes.tableCell}>{di.name}</td>
              <td className={classes.tableCell}>{di.description}</td>
              <td className={classes.tableCellValue}>
                {numeral(di.usd).format("0.00")} {di.type == 2 && "%"}
              </td>
              <td className={classes.tableCellValue}>
                {numeral(di.eur).format("0.00")} {di.type == 2 && "%"}
              </td>
              <td className={classes.tableCellValue}>
                {numeral(di.gbp).format("0.00")} {di.type == 2 && "%"}
              </td>
              <td className={classes.tableCellValue}>
                {numeral(di.cad).format("0.00")} {di.type == 2 && "%"}
              </td>
              <td className={classes.tableCellValue}>
                {numeral(di.zar).format("0.00")} {di.type == 2 && "%"}
              </td>
              <td className={classes.tableCell}>{di.variety ? di.variety : "ALL"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const EstimatedCostRoyalties = withStyles(styles)(EstimatedCostRoyaltiesUnstyled);

export const EstimatedCostGrid = withStyles(styles, { withTheme: true })(EstimatedCostGridUnstyled);
